// @flow

import React from 'react';
import styled from 'styled-components';
import Button from './Button';

const ButtonWrapper = styled(Button)`
  i {
    vertical-align: initial;
  }
`;

type Props = {
  children: any,
  onClick: Function,
};
type States = {
  loading: false,
};

class SubmitButton extends React.PureComponent<Props, States> {
  isUnmounted = false;

  state = {
    loading: false,
  };

  componentWillUnmount() {
    this.isUnmounted = true;
  }

  // TODO: Resolve this! $FlowFixMe
  handleClick = event => {
    const { onClick } = this.props;

    if (!onClick) return null;

    const cancel = () => {
      !this.isUnmounted && this.setState({ loading: false });
    };
    // TODO: Resolve this! $FlowFixMe
    return this.setState({ loading: true }, () => Promise.resolve(onClick(event))
      .then(data => {
        cancel();
        return data;
      })
      .catch(err => {
        cancel();
        return Promise.reject(err);
      })
    );
  };

  render() {
    const { loading } = this.state;
    const { children, ...others } = this.props;

    return (
      /* TODO: Resolve this! $FlowFixMe */
      <ButtonWrapper {...others} loading={loading} onClick={this.handleClick}>
        {children}
      </ButtonWrapper>
    );
  }
}

export default SubmitButton;
